// primarily used to identify layers during hover events
// kept alone here to avoid cirular dependency issues
export enum LayerId {
    Hotspots = "hotspots-composite-layer",
    HotspotPoints = "hotspot-points-scatterplot-layer",
    HotspotLabels = "hotspot-labels-text-layer",

    FirePerimeters = "fire-perimeter-geometrylines",

    FlightPaths = "flight-paths",
    FlightPathImagePoints = "flight-path-image-points",
    Icons = "map-icons-icon-layer",

    LightningStrikeIcons = "LightningStrikesLayer-icons",
}
